import { render, staticRenderFns } from "./WithdrawRecord.vue?vue&type=template&id=8471d458&scoped=true"
import script from "./WithdrawRecord.vue?vue&type=script&lang=js"
export * from "./WithdrawRecord.vue?vue&type=script&lang=js"
import style0 from "./WithdrawRecord.vue?vue&type=style&index=0&id=8471d458&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8471d458",
  null
  
)

export default component.exports